module.exports = __webpack_public_path__ + "img/03-title-03.d38cd511.png";